import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import {
  PartnerItemWrapper,
  imageStyle,
} from './styles/StrategicPartnerItem.styles';
import { StrategicPartnerItemProps } from './types/StrategicPartnerItem.types';

const StrategicPartnerItem = ({ partner }: StrategicPartnerItemProps) => (
  <PartnerItemWrapper>
    <GatsbyImage
      image={getImage(partner.partnerLogo) as IGatsbyImageData}
      alt={partner.partnerName}
      css={imageStyle}
    />
  </PartnerItemWrapper>
);

export default StrategicPartnerItem;
